import { useSSEStream } from '../useSSEStream';

// Types for the task objectives stream
type TaskObjectivesMessage = {
  dimensions?: Record<string, string[] | { demands: string[] }>;
};

interface UseGenerateTaskPropertyProps {
  property: 'objectives' | 'description' | 'rubric';
  moduleId: string;
  version: string;
  taskId: string;
  onMessage: (data: TaskObjectivesMessage) => void;
  onServerClose: (finalMessage: { valid: boolean, data: Record<string, unknown> }) => void;
  onError: (error: Error) => void;
}

/**
 * Hook for streaming AI-generated content for task editing
 * Handles task descriptions, objectives, and rubrics independently
 */
export const useGenerateTaskProperty = ({
  property, moduleId, version, taskId, onMessage, onServerClose, onError,
}: UseGenerateTaskPropertyProps) => {
  const url = `/modules/${moduleId}/versions/${version}/tasks/${taskId}/generate/${property}/stream`;

  const {
    startStream,
    stopStream,
    isStreaming,
    error,
  } = useSSEStream<TaskObjectivesMessage, Record<string, unknown>>({
    source: url,
    method: 'POST',
    onMessage,
    onServerClose,
    onError,
  });

  return {
    startStream,
    stopStream,
    isStreaming,
    error,
  };
};

export default useGenerateTaskProperty;
